import { render, staticRenderFns } from "./OffersPageHeader.vue?vue&type=template&id=23d0ab9c&scoped=true"
import script from "./OffersPageHeader.vue?vue&type=script&lang=js"
export * from "./OffersPageHeader.vue?vue&type=script&lang=js"
import style0 from "./OffersPageHeader.vue?vue&type=style&index=0&id=23d0ab9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d0ab9c",
  null
  
)

export default component.exports